'use client';

import dynamic from 'next/dynamic';
import { useSearchParams } from 'next/navigation';
import { useUser } from '@/app_lib/providers/UserProvider';

// This will prevent showing the code in the browser UNLESS we are signed in
const AdminBarData = dynamic(() => import('@/app/_components/dev/AdminBarData').then((mod) => mod.AdminBarData), {
  ssr: false,
});

interface AdminBarProps {
  pageId: number;
}

export const AdminBar = ({ pageId }: AdminBarProps) => {
  const searchParams = useSearchParams(); // NEEDS SUSPENSE!!
  const showAdminBar = searchParams?.get('showAdminBar');
  const {
    userAccess: { data, loggedIn },
  } = useUser();

  if (!(showAdminBar && loggedIn)) {
    return null;
  }

  if (process.env.ENVIRONMENT === 'prod' && !data?.email.includes('@fortune.com')) {
    return null;
  }

  return <AdminBarData pageId={pageId} />;
};
